import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    height: "calc(100vh - 58px)",
    minHeight: 0,
    width: "100%",
    overflowY: "hidden",
    backgroundColor: theme.palette.type === "dark" ? theme.palette.background.default : "#f7f9fc",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100dvh - 58px)",
    },
  },
  chatPapper: {
    display: "flex",
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  workspaceGrid: {
    flex: 1,
    height: "100%",
    minHeight: 0,
    minWidth: 0,
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  contactsWrapperSmall: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    minWidth: 0,
    overflow: "hidden",
    flexDirection: "column",
  },
  welcomeMsg: {
    backgroundColor: theme.palette.type === "dark" ? theme.palette.background.default : "#fbfcfe",
    borderLeft: `1px solid ${theme.palette.type === "dark" ? "#263247" : "#e7edf5"}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    color: theme.palette.type === "dark" ? "#9aa5b8" : "#718096",
    fontSize: 14,
    textAlign: "center",
    borderRadius: 0,
  },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        <Grid container spacing={0} className={classes.workspaceGrid}>
          <Grid
            item
            xs={12}
            md={3}
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager />
          </Grid>
          <Grid item xs={12} md={9} className={classes.messagessWrapper}>
            {/* <Grid item xs={8} className={classes.messagessWrapper}> */}
            {ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg}>
                  {/* <Paper square variant="outlined" className={classes.welcomeMsg}> */}
                  <span>{i18n.t("chat.noTicketMessage")}</span>
                </Paper>
              </Hidden>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Chat;
